import * as React from "react";
import { brand } from "@carvana/helios-styles";

const DocReview = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={38} height={45} fill="none">
    <path
      fill={brand.tertiary}
      fillRule="evenodd"
      d="M2.5 4a2 2 0 0 1 2-2h18.757a2 2 0 0 1 .243.015V7c0 1.102.891 2 1.998 2h4.987c.01.08.015.16.015.24V21a1 1 0 1 0 2 0V9.24a3.994 3.994 0 0 0-1.172-2.826l-5.242-5.242A4 4 0 0 0 23.257 0H4.5a4 4 0 0 0-4 4v30c0 2.208 1.787 4 3.997 4H15.5a1 1 0 1 0 0-2H4.497A1.997 1.997 0 0 1 2.5 34V4Zm23-.586L29.086 7H25.5V3.414Z"
      clipRule="evenodd"
    />
    <path
      fill={brand.tertiary}
      fillRule="evenodd"
      d="M28.5 42a6.97 6.97 0 0 0 4.2-1.4c.028.038.059.073.093.107l3.122 3.122a1 1 0 0 0 1.414-1.414l-3.122-3.122a1.018 1.018 0 0 0-.107-.093 7 7 0 1 0-5.6 2.8Zm0-2a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"
      clipRule="evenodd"
    />
    <path
      fill={brand.tertiary}
      d="M7.5 13a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2h-18ZM6.5 20a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2h-18a1 1 0 0 1-1-1ZM7.5 25a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-8Z"
    />
  </svg>
);

export default DocReview;
